export const GET_TEMPLATES = 'customerBackend/mail/design/GET_TEMPLATES';
export const CREATE_NEW_MAIL_TEMPLATE = 'customerBackend/mail/design/CREATE_NEW_MAIL_TEMPLATE';
export const UPDATE_MAIL_TEMPLATE = 'customerBackend/mail/design/UPDATE_MAIL_TEMPLATE';

export type MailTemplateIdentifier = string | number;
export type MailTemplateFlag = boolean | 0 | 1 | null;

export interface MailTemplateContent {
  templateId?: MailTemplateIdentifier;
  name?: string;
  type?: string;
  language?: string;
  subject?: string;
  html?: string;
  plain?: string | null;
  du?: MailTemplateFlag;
  sie?: MailTemplateFlag;
  isActive?: MailTemplateFlag;
  herzlich?: MailTemplateFlag;
  professionell?: MailTemplateFlag;
  sachlich?: MailTemplateFlag;
  fromIch?: MailTemplateFlag;
  fromTeam?: MailTemplateFlag;
  trails?: string | number;
  rewards?: string | number;
  mailTemplateRef?: string;
}

export const getTemplates = () => ({
  type: GET_TEMPLATES,
  meta: {
    type: 'api',
    url: `mailTemplates/templates`,
    method: 'get',
  },
});


export const saveNewVersion = (content: MailTemplateContent) => ({
  type: CREATE_NEW_MAIL_TEMPLATE,
  meta: {
    type: 'api',
    url: `mailTemplates/templates`,
    method: 'post',
    data: content,
  },
});

export const updateMailTemplate = (
  content: MailTemplateContent,
  templateId: MailTemplateIdentifier,
) => ({
  type: UPDATE_MAIL_TEMPLATE,
  meta: {
    type: 'api',
    url: `mailTemplates/templates/${templateId}`,
    method: 'put',
    data:{
      ...content,
      templateId,
    },
  },
});
